<script>
  import { onMount } from 'svelte';
  import { t9n } from '../translate';
  import { TS } from '../../config/translation-keys.js';

  export let paging_data;
  export let get_page_data_fn;
  // ;

  const init_pagi = () => {};

  // translated strings ------------------------------------------------------ //

  let button_prev = '<';
  let button_next = '>';

  onMount(init_pagi);

  // reactive functions ------------------------------------------------------- //

  // $: {
  //     button_prev = t9n(TS.TABLE_BUTTON_PREV);
  //     button_next = t9n(TS.TABLE_BUTTON_NEXT);
  // }

  const get_prev_page = () => {
    get_page_data_fn(paging_data.current_page - 1);
  };

  const get_next_page = () => {
    get_page_data_fn(paging_data.current_page + 1);
  };
</script>

<div class="pagination">
  {#if paging_data && paging_data.number_of_pages > 1}
    <span class="prev">
      <button
        on:click={get_prev_page}
        class="mdc-button mdc-button--unelevated margin-5"
        class:inactive={paging_data.current_page <= 1}>
        {button_prev}
      </button>
    </span>

    <span class="current">
      page {paging_data.current_page} of {paging_data.number_of_pages}
    </span>

    <span class="next">
      <button
        on:click={get_next_page}
        class="mdc-button mdc-button--unelevated margin-5"
        class:inactive={paging_data.current_page >= paging_data.number_of_pages}>
        {button_next}
      </button>
    </span>
  {/if}
</div>

<style>
  .pagination {
    display: block;
    width: 100%;
    text-align: center;
    margin: 2em 0;
  }

  .pagination span {
    display: inline-block;
  }

  .pagination button.inactive {
    visibility: hidden;
  }

  .pagination button:hover {
    filter: brightness(110%);
  }

  .pagination button:active {
    filter: brightness(150%);
  }

  /*.pagination button:focus {*/
  /*  outline: 10px;*/
  /*}*/

  /*.paginaton .prev button {*/
  /*  margin-right: 5em;*/
  /*}*/

  /*.paginaton .next button {*/
  /*  margin-left: 5em;*/
  /*}*/
</style>
